import { motion } from "framer-motion"

interface LandingIconAnimatedActivityProps {
  className?: string
}

export function LandingIconAnimatedActivity({ className }: LandingIconAnimatedActivityProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      <title>Activity</title>
      {/* First bar - stable bottom, animated top */}
      <line x1="18" y1="20" x2="18" y2="10" />
      <motion.line
        x1="18"
        y1="10"
        x2="18"
        y2="4"
        initial={{ y2: 10 }}
        animate={{ y2: [10, 4, 10] }}
        transition={{
          repeat: Number.POSITIVE_INFINITY,
          duration: 0.8,
          ease: "easeInOut",
          repeatType: "mirror",
          delay: 0,
        }}
      />

      {/* Second bar - stable bottom, animated top */}
      <line x1="12" y1="20" x2="12" y2="4" />
      <motion.line
        x1="12"
        y1="4"
        x2="12"
        y2="2"
        initial={{ y2: 4 }}
        animate={{ y2: [4, 2, 4] }}
        transition={{
          repeat: Number.POSITIVE_INFINITY,
          duration: 0.8,
          ease: "easeInOut",
          repeatType: "mirror",
          delay: 0.075,
        }}
      />

      {/* Third bar - stable bottom, animated top */}
      <line x1="6" y1="20" x2="6" y2="10" />
      <motion.line
        x1="6"
        y1="10"
        x2="6"
        y2="6"
        initial={{ y2: 10 }}
        animate={{ y2: [10, 6, 10] }}
        transition={{
          repeat: Number.POSITIVE_INFINITY,
          duration: 0.8,
          ease: "easeInOut",
          repeatType: "mirror",
          delay: 0.15,
        }}
      />
    </svg>
  )
}
